import bronzeBadge from '@/assets/images/bronze-badge.svg';
import diamondBadge from '@/assets/images/diamond-badge.svg';
import goldBadge from '@/assets/images/gold-badge.svg';
import ironBadge from '@/assets/images/iron-badge.svg';
import legendaryBadge from '@/assets/images/legendary-badge.svg';
import platinumBadge from '@/assets/images/platinum-badge.svg';
import silverBadge from '@/assets/images/silver-badge.svg';

export const badges = [
  {
    id: '1',
    level: 1,
    name: 'Iron',
    icon: ironBadge,
    point: 10,
    progressColor: 'bg-[#6D8192]',
    textColor: 'text-[#6D8192]',
  },
  {
    id: '2',
    level: 2,
    name: 'Bronze',
    icon: bronzeBadge,
    point: 25,
    progressColor: 'bg-[#B8531B]',
    textColor: 'text-[#B8531B]',
  },
  {
    id: '3',
    level: 3,
    name: 'Silver',
    icon: silverBadge,
    point: 100,
    progressColor: 'bg-[#A8B3CF]',
    textColor: 'text-[#A8B3CF]',
  },
  {
    id: '4',
    level: 4,
    name: 'Gold',
    icon: goldBadge,
    point: 150,
    progressColor: 'bg-[#FF8E3B]',
    textColor: 'text-[#FF8E3B]',
  },
  {
    id: '5',
    level: 5,
    name: 'Platinum',
    icon: platinumBadge,
    point: 300,
    progressColor: 'bg-[#2CDCE6]',
    textColor: 'text-[#2CDCE6]',
  },
  {
    id: '6',
    level: 6,
    name: 'Diamond',
    icon: diamondBadge,
    point: 500,
    progressColor: 'bg-[#7147ED]',
    textColor: 'text-[#7147ED]',
  },
  {
    id: '7',
    level: 7,
    name: 'Legendary',
    icon: legendaryBadge,
    point: 1000,
    progressColor: 'bg-[#E04337]',
    textColor: 'text-[#E04337]',
  },
];
